import { ProductTemplateContent } from '@/assets/interface/Product';
import { filter } from 'lodash';
import { Validator, RuleValidate, Rule } from 'vee-validate';

Validator.extend('noDuplicate', {
    getMessage: () => 'no duplicate field name',
    validate(value, arrayList) {
        const filtered = filter(arrayList, theValue => theValue.title === value);
        return filtered.length <= 1;
    },
});
